package pl.mothdigital.neuronowi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initStatutPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Statut.md", FrontMatterElement.EmptyMap))
}

@Page("/statut")
@Composable
fun StatutPage() {
    pl.mothdigital.neuronowi.components.layouts.MarkdownLayout("Statut", "Niepublicznej Poradni Psychologiczno-Pedagogicznej „Centrum Terapii NeuroNowi” Sp. z o.o.") {
        org.jetbrains.compose.web.dom.H1(attrs = { id("statut") }) {
            org.jetbrains.compose.web.dom.Text("STATUT")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Niepublicznej Poradni Psychologiczno-Pedagogicznej „Centrum Terapii NeuroNowi” Sp. z o.o. ul. Fabryczna 17a/1, 65-410 Zielona Góra")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("i-postanowienia-ogólne") }) {
            org.jetbrains.compose.web.dom.Text("I. Postanowienia ogólne")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Niepubliczna Poradnia Psychologiczno-Pedagogiczna „Centrum Terapii NeuroNowi” Sp. z o.o., zwana dalej „Poradnią”, działa na podstawie:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Ustawy z dnia 14 grudnia 2016 r. – Prawo oświatowe (Dz.U. z 2023 r. poz. 900 z późn. zm.);")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Ustawy z dnia 6 listopada 2008 r. o prawach pacjenta i Rzeczniku Praw Pacjenta;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Ustawy z dnia 15 kwietnia 2011 r. o działalności leczniczej (jeśli dotyczy);")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Rozporządzeń Ministra Edukacji i Nauki dotyczących organizowania pomocy psychologiczno-pedagogicznej i WWRD;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (RODO);")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Niniejszego Statutu.")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Siedziba Poradni znajduje się w Zielonej Górze, przy ul. Fabrycznej 17a/1.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Organem prowadzącym Poradnię jest spółka z ograniczoną odpowiedzialnością „Centrum Terapii NeuroNowi” Sp. z o.o., której wspólniczkami i zarządzającymi są Magdalena Nowik i Żaklina Wykręt.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia działa na podstawie wpisu do ewidencji szkół i placówek niepublicznych prowadzonego przez Prezydenta Miasta Zielona Góra.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("ii-cele-i-zadania-poradni") }) {
            org.jetbrains.compose.web.dom.Text("II. Cele i zadania Poradni")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Celem Poradni jest wspieranie rozwoju psychicznego, emocjonalnego, społecznego, poznawczego i komunikacyjnego dzieci i młodzieży oraz dorosłych oraz wspomaganie ich rodzin i opiekunów.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zadania Poradni obejmują w szczególności: a) wczesne wspomaganie rozwoju dziecka (WWRD), b) diagnozy psychologiczne, pedagogiczne, logopedyczne i integracji sensorycznej, c) prowadzenie terapii: psychologicznej, pedagogicznej, logopedycznej, integracji sensorycznej, terapii ręki, terapii EEG Biofidbek, terapii słuchowych, terapii neurotaktylnej, zajęcia TUS i innych, d) wydawanie informacji i zaświadczeń, e) udzielanie konsultacji i wsparcia rodzicom, nauczycielom, wychowawcom i specjalistom, f) prowadzenie zajęć edukacyjnych, warsztatów, mediacji oraz działań profilaktycznych.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("iii-organizacja-pracy-poradni") }) {
            org.jetbrains.compose.web.dom.Text("III. Organizacja pracy Poradni")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Organami Poradni są: a) Dyrektor, b) Zespół specjalistów.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Do zadań Dyrektora Poradni należy w szczególności: a) kierowanie działalnością Poradni i reprezentowanie jej na zewnątrz, b) powołanie oraz koordynacja prac Zespołu Wczesnego Wspomagania Rozwoju, c) organizacja administracyjna i gospodarcza Poradni.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zespół specjalistów składa się z Dyrektora oraz pedagogów, psychologów, logopedów i innych specjalistów, w tym nauczycieli oraz doradców zatrudnionych w Poradni.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia funkcjonuje przez cały rok, z wyłączeniem dni ustawowo wolnych od pracy oraz dni wskazanych w harmonogramie przerw.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Terminy zajęć i konsultacji są ustalane indywidualnie z rodzicami lub opiekunami prawnymi.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Warunkiem uczestnictwa dziecka w zajęciach jest podpisanie przez rodzica/opiekuna umowy określającej zasady uczestnictwa w zajęciach odpłatnych i nie odpłatnych.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zajęcia odbywają się w obecności rodzica/opiekuna, o ile nie ustalono inaczej.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Nieobecność dziecka należy zgłaszać najpóźniej 24 godziny przed zaplanowanymi zajęciami. Zajęcia nieodwołane przepadają bez możliwości odpracowania.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zajęcia odwołane przez terapeutę są odpracowywane w ustalonym wspólnie terminie.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Rodzice są zobowiązani do informowania Poradni o stanie zdrowia dziecka, w szczególności o chorobach zakaźnych lub przeciwwskazaniach do terapii.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("iv-kadra-i-formy-działania") }) {
            org.jetbrains.compose.web.dom.Text("IV. Kadra i formy działania")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Poradnia zatrudnia specjalistów posiadających odpowiednie kwalifikacje. W skład zespołu wchodzą osoby posiadające przygotowanie do pracy z małymi dziećmi o zaburzonym rozwoju psychoruchowym: a) pedagog posiadający kwalifikacje odpowiednie do rodzaju niepełnosprawności dziecka, w szczególności: oligofrenopedagog, tyflopedagog lub surdopedagog, pedagog specjalny; b) psycholog; c) logopeda/neurologopeda; d) inni specjaliści - w zależności od potrzeb dziecka i jego rodziny.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Do zadań zespołu należy w szczególności: a) ustalenie, na podstawie opinii o potrzebie wczesnego wspomagania rozwoju dziecka, kierunków i harmonogramu działań w zakresie wczesnego wspomagania i wsparcia rodziny dziecka; b) opracowanie i realizowanie z dzieckiem i jego rodziną indywidualnego programu wczesnego wspomagania, z uwzględnieniem działań wspomagających rodzinę dziecka w zakresie realizacji programu, koordynowania działań specjalistów prowadzących zajęcia z dzieckiem oraz oceniania postępów dziecka; c) analizowanie skuteczności pomocy udzielanej dziecku i jego rodzinie, wprowadzanie zmian w indywidualnym programie wczesnego wspomagania, stosownie do potrzeb dziecka i jego rodziny, oraz planowanie dalszych działań w zakresie wczesnego wspomagania, d) w razie potrzeby - nawiązanie współpracy z podmiotem leczniczym lub ośrodkiem pomocy społecznej w celu zapewnienia dziecku rehabilitacji, terapii lub innych form pomocy;")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Zespół dokumentuje działania prowadzone w ramach indywidualnego programu wczesnego wspomagania.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Zajęcia w ramach wczesnego wspomagania organizuje się w wymiarze od 4 do 8 godzin w miesiącu, w zależności od możliwości psychofizycznych i potrzeb dziecka.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Zajęcia w ramach wczesnego wspomagania są prowadzone indywidualnie z dzieckiem i jego rodziną.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("W przypadku dzieci, które ukończyły 3 rok życia, zajęcia w ramach wczesnego wspomagania mogą być prowadzone w grupach liczących 2 lub 4 dzieci, z udziałem ich rodzin.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Zajęcia w ramach wczesnego wspomagania, w szczególności z dziećmi, które nie ukończyły 3 roku życia, są prowadzone indywidualnie z udziałem rodzica lub opiekuna prawnego.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Miejsce prowadzenia zajęć w ramach wczesnego wspomagania ustala dyrektor, w uzgodnieniu z rodzicami (prawnymi opiekunami) dziecka.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Zespół współpracuje z rodziną dziecka w szczególności przez: a) udzielanie pomocy w zakresie kształtowania postaw i zachowań pożądanych w kontaktach z dzieckiem: wzmacnianie więzi emocjonalnej pomiędzy rodzicami i dzieckiem, rozpoznawanie zachowań dziecka i utrwalanie właściwych reakcji na te zachowania; b) udzielanie instruktażu i porad oraz prowadzenie konsultacji w zakresie pracy z dzieckiem; c) pomoc w przystosowaniu warunków w środowisku domowym do potrzeb dziecka oraz w pozyskaniu i wykorzystaniu w pracy z dzieckiem odpowiednich środków dydaktycznych i niezbędnego sprzętu.")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text("Działania Poradni obejmują: a) diagnozę, opiniowanie i zaświadczenia w formie nieodpłatnej i odpłatnej; b) terapię indywidualną i grupową w formie nieodpłatnej i odpłatnej; c) konsultacje rodzinne i środowiskowe nieodpłatnie i odpłatnie; d) wsparcie kryzysowe i interwencje; e) współpracę z placówkami oświatowymi, medycznymi i organizacjami społecznymi.")
                }
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("v-dokumentacja-i-nadzór") }) {
            org.jetbrains.compose.web.dom.Text("V. Dokumentacja i nadzór")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia prowadzi dokumentację zgodnie z przepisami oświatowymi i przepisami o ochronie danych osobowych.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dokumentacja obejmuje m.in.:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("kartoteki pacjentów,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("dzienniki zajęć,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("rejestry opinii i orzeczeń,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("harmonogramy pracy,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("listy obecności i protokoły zespołów diagnostycznych.")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia podlega nadzorowi pedagogicznemu Kuratora Oświaty.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("vi-ochrona-danych-osobowych") }) {
            org.jetbrains.compose.web.dom.Text("VI. Ochrona danych osobowych")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia zapewnia ochronę danych osobowych zgodnie z przepisami RODO oraz ustawą o prawach pacjenta.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dane osobowe dzieci i rodziców/opiekunów są wykorzystywane wyłącznie do celów diagnostycznych, terapeutycznych i administracyjnych.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Personel Poradni zobowiązany jest do zachowania tajemnicy zawodowej i poufności.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("vii-współpraca-z-instytucjami") }) {
            org.jetbrains.compose.web.dom.Text("VII. Współpraca z instytucjami")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia współpracuje z:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("przedszkolami, szkołami i placówkami oświatowymi,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("jednostkami samorządu terytorialnego,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("innymi poradniami i placówkami medycznymi,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("organizacjami pozarządowymi oraz instytucjami kultury.")
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("viii-skargi-i-reklamacje") }) {
            org.jetbrains.compose.web.dom.Text("VIII. Skargi i reklamacje")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Skargi i reklamacje dotyczące funkcjonowania Poradni mogą być składane osobiście, pisemnie lub elektronicznie do dyrektora Poradni pod adres: ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowizg@gmail.com") {
                    org.jetbrains.compose.web.dom.Text("neuronowizg@gmail.com")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Każda skarga rozpatrywana jest w terminie do 14 dni od dnia jej złożenia.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Odpowiedź udzielana jest w tej samej formie, w jakiej została złożona skarga.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia zastrzega sobie prawo do dokonywania zmian w statucie w każdym czasie, o czym klient zostanie powiadomiony poprzez wywieszenie stosownej informacji w siedzibie NPPP Centrum terapii NeuroNowi lub zamieszczenie jej na stronie internetowej.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("ix-postanowienia-końcowe") }) {
            org.jetbrains.compose.web.dom.Text("IX. Postanowienia końcowe")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Statut wchodzi w życie z dniem wpisu Poradni do ewidencji szkół i placówek niepublicznych.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wszelkie zmiany w statucie wymagają formy pisemnej i zgłoszenia do organu ewidencyjnego.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("W sprawach nieuregulowanych niniejszym Statutem zastosowanie mają odpowiednie przepisy prawa oświatowego, cywilnego oraz inne właściwe akty prawne.")
            }
        }
    }
}
